import store from "./store/index.js";

export function isUserAllowed(allowed) {
  return allowed.some((i) => store.getters.getUserType.includes(i));
}

export function getUserLogin() {
  return store.getters.getUserLogin;
}
